import { Component, OnDestroy, OnInit } from '@angular/core';
import { highchartChatBreakdownConfig } from '@projects/shared/src/app/modules/widgets/components/base-highchart/highcharts-config/highchart-chat-breakdown-config';
import { hightchartDashboardChatVolumeConfig } from '@projects/shared/src/app/modules/widgets/components/base-highchart/highcharts-config/highchart-dahboard-chat-volume-config';
import { Options } from 'highcharts';
import { CheckPermission, momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { GetChatDashboardStatsResponse } from '../../interfaces/dashboard/GetChatDashboardStatsResponse';
import { TranscriptResponse } from '../../interfaces/dashboard/TranscriptResponse';
import {
  TranscriptHourlyResponse,
  TranscriptsHourlyStatisticsResponse,
} from '../../interfaces/Reporting/TranscriptsHourlyStatisticsResponse';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { AuthenticationService } from '@app/core';
import { CardsService } from '@projects/shared/src/app/modules/widgets/components/cards/cards.service';
import { highchartChatDashboardStatsConfig } from '@projects/shared/src/app/modules/widgets/components/base-highchart/highcharts-config/highchart-chat-dashboard-statistics-config';
import { ChatStatisticsResponse } from '../../../insight/interfaces/Dashboard/ChatStatisticsResponse';
import { ChatChannelStatsResponse } from '../../interfaces/dashboard/ChatChannelStatsResponse';
import { highchartChatChannelTrackConfig } from '@projects/shared/src/app/modules/widgets/components/base-highchart/highcharts-config/highchart-chat-channel-track-config';
import { ReportingService } from '../../services/reporting/reporting.service';
import { IPaginate } from '@projects/shared/src/app/modules/pagination/paginate.pipe';
import { Subscription } from 'rxjs';
import { SignalrService } from '@app/core/signalr.service';
import { RealTimeEvents } from '@app/core/signalr.events';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { ParticipantChannelType } from '../../interfaces/transcript/ConversationAndOfflineMessagesResponse';
import { CLOSED_BY } from '../transcript-detail/transcript-detail.component';
import { ThemesService } from '../../../setting/services/themes.service';
import { NavService } from '@projects/shared/src/app/services/nav.service';

@Component({
  selector: 'app-chat-dashboard',
  templateUrl: './chat-dashboard.component.html',
  styleUrls: ['./chat-dashboard.component.scss'],
})
export class ChatDashboardComponent implements OnInit, OnDestroy {
  checkPermission = CheckPermission;
  moment = moment;
  chatVolume: TranscriptsHourlyStatisticsResponse | undefined;
  hourWiseChatData: Array<TranscriptHourlyResponse> = [
    {
      Hour: 0,
      PerHourCount: 0,
    },
    {
      Hour: 1,
      PerHourCount: 0,
    },
    {
      Hour: 2,
      PerHourCount: 0,
    },
    {
      Hour: 3,
      PerHourCount: 0,
    },
    {
      Hour: 4,
      PerHourCount: 0,
    },
    {
      Hour: 5,
      PerHourCount: 0,
    },
    {
      Hour: 6,
      PerHourCount: 0,
    },
    {
      Hour: 7,
      PerHourCount: 0,
    },
    {
      Hour: 8,
      PerHourCount: 0,
    },
    {
      Hour: 9,
      PerHourCount: 0,
    },
  ];
  hourWiseOfflineChatData: Array<TranscriptHourlyResponse> = [
    {
      Hour: 0,
      PerHourCount: 0,
    },
    {
      Hour: 1,
      PerHourCount: 0,
    },
    {
      Hour: 2,
      PerHourCount: 0,
    },
    {
      Hour: 3,
      PerHourCount: 0,
    },
    {
      Hour: 4,
      PerHourCount: 0,
    },
    {
      Hour: 5,
      PerHourCount: 0,
    },
    {
      Hour: 6,
      PerHourCount: 0,
    },
    {
      Hour: 7,
      PerHourCount: 0,
    },
    {
      Hour: 8,
      PerHourCount: 0,
    },
    {
      Hour: 9,
      PerHourCount: 0,
    },
  ];

  tchatVolume: TranscriptsHourlyStatisticsResponse = {
    HourlyChat: this.hourWiseChatData,
    HourlyOfflineMessage: this.hourWiseOfflineChatData,
  };
  chatVolumeConfig: Options | undefined;

  chatBreakdown: GetChatDashboardStatsResponse = {
    TotalActiveChats: 0,
    TotalChats: 0,
    TotalClosedChats: 0,
    TotalMissedChats: 0,
    TotalOfflineMessages: 0,
    GuidedChatCount: 0,
    PendingRequestsCount: 0
  };
  // tchatBreakdown: GetChatDashboardStatsResponse = {
  //   TotalActiveChats: 0,
  //   TotalChats: 0,
  //   TotalClosedChats: 0,
  //   TotalMissedChats: 0,
  //   TotalOfflineMessages: 0,
  // };
  chatBreakdownConfig: Options | undefined;

  chatChannelStats: Array<ChatChannelStatsResponse> | undefined;
  tchatChannelStats: Array<ChatChannelStatsResponse> = [
    {
      Name: 'Web',
      Count: 0,
    },
    {
      Name: 'SMS',
      Count: 0,
    },
    {
      Name: 'Whatsapp',
      Count: 0,
    },
    {
      Name: 'Messenger',
      Count: 0,
    },
  ];
  chatChannelTrackConfig: Options | undefined;

  conversationRateConfig: Options | undefined;
  visitorToChatConfig: Options | undefined;
  chatStatistics: ChatStatisticsResponse | undefined;
  tchatStatistics: ChatStatisticsResponse = {
    AverageResolutionTime: 0,
    AverageResponseTime: 0,
    AverageWaitTime: 0,
    ConversionRate: 0,
    VisitorToChat: 0,
  };
  recentTranscripts: Array<TranscriptResponse> = [];
  campaignList = [{ Id: '', Name: '', Code: 'All' }];
  campaignObject: { Id: string; Name: string; Code: string } = { Id: '', Name: '', Code: 'All' };
  currentStartDate: string;
  currentEndDate: string;

  selectedDateRange: Array<string> = [moment().startOf('day').toISOString(), moment().endOf('day').toISOString()];
  //date range identifiers
  identifiers: Array<{
    label: string;
    value: Array<string>;
  }> = [
    { label: 'Today', value: [moment().startOf('day').toISOString(), moment().endOf('day').toISOString()] },
    {
      label: 'Last 24H',
      value: [moment().subtract(24, 'hours').toISOString(), moment().toISOString()],
    },
    {
      label: 'Last Week',
      value: [
        moment().startOf('week').subtract(1, 'week').toISOString(),
        moment().startOf('week').subtract(1, 'day').toISOString(),
      ],
    },
    {
      label: 'Last 15 Days',
      value: [moment().subtract(15, 'days').startOf('day').toISOString(), moment().endOf('day').toISOString()],
    },
  ];

  transcriptColumns = [
    { name: '', key: 'channel_type', display: true },
    { name: 'Chat No.', key: 'nick_name', display: true },
    { name: 'Agent', key: 'agent_info.name', sort: false, display: true },
    { name: 'URL', key: 'site.url', sort: false, display: true },
    { name: 'TFN', key: 'site.tfn', sort: false, display: true },
    { name: 'Campaign', key: 'campaign_name', sort: false, display: true },
    { name: 'Disposition', key: 'disposition', sort: false, display: true },
    { name: 'Messages', key: 'message_count', display: true },
    { name: 'Date', key: 'created_on', display: true },
    { name: 'Action', key: 'action', display: true },
  ];

  totalCount = 0;
  data: any[] = [];
  transcriptsRows: any[] = [];
  filter: any = { limit: 15, skip: 0 };
  subscriptions = new Array<Subscription>();
  channelType = ChannelType;
  selectedCampaignId: string = '';

  public pagingConfig: IPaginate = {
    id: 'recent-chats',
    itemsPerPage: 5,
    currentPage: 1,
    totalItems: this.totalCount,
  };

  constructor(
    private chatDashboardService: DashboardService,
    private reportingService: ReportingService,
    private signalRService: SignalrService,
    public authService: AuthenticationService,
    private toast: ToastService,
    public navService: NavService,
    private themeService: ThemesService
  ) {
    this.currentStartDate = moment().startOf('day').toISOString();
    this.currentEndDate = moment().endOf('day').toISOString();

    //* Campaign Drop Down Data
    this.campaignList = this.authService.getAllClientCampaigns() ?? [];
    this.campaignList.unshift({ Id: '', Name: '', Code: 'All' });
    this.campaignObject =
      this.campaignList && this.campaignList.length > 0 ? this.campaignList[0] : { Id: '', Name: '', Code: 'All' };

    this.fetchData();
  }

  getChatChannelStats() {
    this.chatDashboardService
      .getChatChannelStats(this.currentStartDate, this.currentEndDate, this.campaignObject.Id)
      .subscribe((data) => {
        if (data === null) return;

        this.chatChannelStats = data.filter(
           item => item.Name?.toLowerCase() !== 'facebookadscampaign'
        );
        this.chatChannelTrackConfig = highchartChatChannelTrackConfig(this.chatChannelStats);
      });
  }
  fetchData() {
    this.getChatChannelStats();
    this.fetchTranscriptAverageCountHourly();
    this.chatDashboardStats();
    this.fetchRecentTranscripts();
    this.getChatStatistics();
  }
  onSelectedCampaignChange(campaignid: any) {
    let selectedCampaign = this.campaignList.find((f: any) => f.Id === campaignid);
    this.campaignObject = selectedCampaign!;
    this.fetchData();
  }

  setCampaignDateFromExternal(data: { campaignId: string; startDate: string; endDate: string }) {
    let selectedCampaign = this.campaignList.find((f: any) => f.Id === data.campaignId);
    this.campaignObject = selectedCampaign!;
    this.currentStartDate = data.startDate;
    this.currentEndDate = data.endDate;

    this.fetchData();
  }

  fetchTranscriptAverageCountHourly() {
    this.reportingService
      .fetchTranscriptsAverageCountHourly(this.currentStartDate, this.currentEndDate, this.campaignObject.Id)
      .subscribe((data) => {
        this.chatVolume = data;
        this.chatVolumeConfig = hightchartDashboardChatVolumeConfig(this.chatVolume);
      });
  }

  chatDashboardStats() {
    this.chatDashboardService
      .getChatDashboardStats(this.currentStartDate, this.currentEndDate, this.campaignObject.Id)
      .subscribe((data) => {
        this.chatBreakdown = data;

        delete this.chatBreakdown.AvgChatPerDay;
        delete this.chatBreakdown.AvgResponseTime;

        this.chatBreakdownConfig = highchartChatBreakdownConfig(
          this.chatBreakdown,
          false,
          this.themeService.getWidgetColors()
        );
      });
  }

  fetchRecentTranscripts() {
    this.chatDashboardService
      .fetchRecentTranscripts(this.currentStartDate, this.currentEndDate, 1, 5, 0, this.campaignObject.Id)
      .subscribe((res) => {
        this.transcriptsRows = this.data = res.transcripts;
        this.totalCount = res.totalCount;
      });
  }

  getChannnelIconByType(channelType: number) {
    return channelType == ParticipantChannelType.Web
      ? 'fa-light fa-globe font-social-icon social-icon'
      : channelType == ParticipantChannelType.Messenger
      ? 'fa-brands fa-facebook-messenger font-social-icon social-icon social-icon--fb'
      : channelType == ParticipantChannelType.WhatsApp
      ? 'fa-brands fa-whatsapp font-social-icon social-icon social-icon--wa'
      : channelType == ParticipantChannelType.Instagram
        ? 'fa-brands fa-instagram font-social-icon social-icon social-icon--fb'
      : 'fa-regular fa-comment-sms font-social-icon social-icon social-icon--wa';
  }

  getClosedIcon(dateClosed: Date) {
    return dateClosed == null || dateClosed == undefined
      ? 'fa-light social-icon fa-unlock social-icon--gray social-icon--75x'
      : 'fa-light social-icon fa-lock social-icon--gray social-icon--75x';
  }

  getChatStatistics() {
    this.chatDashboardService
      .getChatStatistics(this.currentStartDate, this.currentEndDate, this.campaignObject.Id)
      .subscribe((data) => {
        if (data === null) return;

        this.chatStatistics = data;
        this.conversationRateConfig = highchartChatDashboardStatsConfig(data.ConversionRate);
        this.visitorToChatConfig = highchartChatDashboardStatsConfig(data.VisitorToChat);
      });
  }

  ngOnInit(): void {
    this.chatBreakdownConfig = highchartChatBreakdownConfig(
      this.chatBreakdown,
      false,
      this.themeService.getWidgetColors()
    );

    this.chatVolume = this.tchatVolume;
    this.chatVolumeConfig = hightchartDashboardChatVolumeConfig(this.chatVolume);

    this.chatStatistics = this.tchatStatistics;
    this.conversationRateConfig = highchartChatDashboardStatsConfig(this.chatStatistics.ConversionRate);
    this.visitorToChatConfig = highchartChatDashboardStatsConfig(this.chatStatistics.VisitorToChat);

    this.chatChannelStats = this.tchatChannelStats;
    this.chatChannelTrackConfig = highchartChatChannelTrackConfig(this.chatChannelStats);

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.NewChatNotification).subscribe((data: any) => {
        console.log(`Signal event => NewChatNotification received with data`, data);

        this.toast.info(`New Incoming Chat`);
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.ReceiveMessage).subscribe((data: any) => {
        console.log(`Signal event => ReceiveMessage received with data`, data);
        var transcript = this.transcriptsRows.find((x) => x.id == data.conversationId);
        if (transcript) {
          transcript.message_count += 1;
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.CustomerChatEndNotification).subscribe((data: any) => {
        console.log(`Signal event => CustomerChatEndNotification received with data`, data);
        if (this.chatBreakdown != undefined) {
          this.chatBreakdown.TotalActiveChats -= 1;
          this.chatBreakdown.TotalClosedChats += 1;
          this.chatBreakdownConfig = highchartChatBreakdownConfig(
            this.chatBreakdown,
            false,
            this.themeService.getWidgetColors()
          );

          if(!data.userId){
            this.chatBreakdown.TotalMissedChats += 1;
          }
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.AgentChatComplete).subscribe((data: any) => {
        console.log(`Signal event => AgentChatComplete received with data`, data);
        if (this.chatBreakdown != undefined) {
          this.chatBreakdown.TotalActiveChats -= 1;
          this.chatBreakdown.TotalClosedChats += 1;
          this.chatBreakdownConfig = highchartChatBreakdownConfig(
            this.chatBreakdown,
            false,
            this.themeService.getWidgetColors()
          );
        }
        var transcript = this.transcriptsRows.find((x) => x.conversation_sid == data.customerConversationSid);
        if (transcript) {
          transcript.disposition = data.disposition;
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.IncomingChatAcceptedNotification).subscribe((data: any) => {
        console.log(`Signal event => IncomingChatAcceptedNotification received with data`, data);
        var transcript = this.transcriptsRows.find((x) => x.conversation_sid == data.customerConversationSid);
        if (transcript) {
          transcript.agent_info = {
            name: data.agentInfo.agentName,
            email: data.agentInfo.email,
          };
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.RatingNotification).subscribe((data: any) => {
        console.log(`Signal event => RatingNotification received with data`, data);
        var transcript = this.transcriptsRows.find((x) => x.id == data.conversationId);
        if (transcript) {
          transcript.has_rated = true;
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.OfflineMessageNotification).subscribe((data: any) => {
        console.log(`Signal event => OfflineMessageNotification received with data`, data);
        if (this.chatBreakdown != undefined) {
          this.chatBreakdown.TotalOfflineMessages += 1;
          this.chatBreakdownConfig = highchartChatBreakdownConfig(
            this.chatBreakdown,
            false,
            this.themeService.getWidgetColors()
          );
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.HandoverChat).subscribe((data: any) => {
        console.log(`Signal event => HandoverChat received with data`, data);

        var transcript = this.transcriptsRows.find((x) => x.id == data.conversationId);
        if (transcript) {
          transcript.agent_info = {
            name: data.agentInfo.agentName,
            email: data.agentInfo.email,
          };
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.IncomingChatNotification).subscribe((data: any) => {
        console.log(`Signal event => IncomingChatNotification received with data`, data);

        var transcript = this.transcriptsRows.find((x) => x.id == data.conversationId);
        if (transcript) {
          return;
        }

        if (this.chatBreakdown != undefined) {
          this.chatBreakdown.TotalChats += 1;
          this.chatBreakdown.TotalActiveChats += 1;
          this.chatBreakdown.AvgChatPerDay! += 1;
          this.chatBreakdownConfig = highchartChatBreakdownConfig(
            this.chatBreakdown,
            false,
            this.themeService.getWidgetColors()
          );
        }
        if (this.transcriptsRows.length == 5) {
          this.transcriptsRows.pop();
        }
        
        this.transcriptsRows.unshift({
          id: data.conversationId,
          conversation_sid: data.customerConversationSid,
          nick_name: data.nickName,
          friendly_name: data.friendlyName,
          created_on: moment(data.dateCreated).format('MM-DD-YYYY hh:mm:ss A'),
          visitor_id: data.visitorId,
          message_count: 1,
          campaign_id: data.campaignId,
          campaign_name: data.campaignName,
          customer_message_count: 1,
          agent_message_count: 0,
          disposition: '',
          has_rated: false,
          site: {
            tfn: data.tfn,
            url: data.customerInfo.siteUrl,
          },
          customer_info: {
            site_url: data.customerInfo.siteUrl,
            name: data.customerInfo.name,
            email: data.customerInfo.email,
            address: {
              country: data.customerInfo.address?.country,
              city: data.customerInfo.address?.city,
              state: data.customerInfo.address?.state,
              zip: data.customerInfo.address?.zip,
              ip: data.customerInfo.address?.ip,
            },
          },
          channel_type: data.channelType,
          returning_visitor: data.returningVisitor,
          rating: 0,
          agent_info: {},
          action: data.conversationId,
        });

        var channelStat = this.chatChannelStats?.find((x) => x.Name == this.channelType[data.channelType].toString());
        if (channelStat) {
          channelStat.Count += 1;
          if (this.chatChannelStats != undefined)
            this.chatChannelTrackConfig = highchartChatChannelTrackConfig(this.chatChannelStats);
        }
      })
    );
  }

  getNameInitials(name: string) {
    if (!name) return '';

    const words = name.split(' ');
    let initials = '';

    // Get the first character of each word for the first two words
    initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join('');

    return initials === '' ? 'FD' : initials;
  }

  getTranscripts() {
    this.chatDashboardService
      .fetchRecentTranscripts(
        this.currentStartDate,
        this.currentEndDate,
        this.pagingConfig?.currentPage,
        this.pagingConfig?.itemsPerPage,
        (this.pagingConfig.currentPage - 1) * this.pagingConfig.itemsPerPage,
        this.campaignObject.Id
      )
      .subscribe((res) => {
        this.transcriptsRows = this.data = res.transcripts;
        this.totalCount = res.totalCount;
      });
  }

  onSelectedDate(values: any) {
    this.currentStartDate = values[0];
    this.currentEndDate = values[1];
    this.fetchData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    //* close right drawer
    this.navService.isShowRightDrawer = false;
  }
}
enum ChannelType {
  Web,
  SMS,
  WhatsApp,
  Messenger,
  All,
}
